import { SystemNotificationSettingsTranslation } from 'locales/de/pages/Messaging/systemNotificationsSettings';

const en: SystemNotificationSettingsTranslation = {
  title: 'System notifications settings',
  systemNotifications: 'System notifications',
  headline: 'Headline',
  content: 'Content',
  startDate: 'Start date',
  endDate: 'End date',
  isActive: 'Active',
  type: 'Type',
  timePeriod: 'Time period',
  notification: 'Notification',
  newSystemNotification: 'New System Notification',
  editSystemNotification: 'System Notification Editing',
  gotIt: 'Got it',
  alerts: {
    error: {
      loadSystemNotifications: 'System notifications could not be loaded.',
      updateSystemNotification: 'System notification could not be edited.',
      createSystemNotification: 'System notification could not be created.',
      deleteSystemNotification: 'System notification could not be deleted.'
    },
    success: {
      updateSystemNotification: 'System notification was successfully edited.',
      createSystemNotification: 'System notification was successfully created.',
      deleteSystemNotification: 'System notification was successfully deleted.'
    }
  },
  deleteConfirm: {
    title: 'Really delete?',
    message: 'Do you really want to delete this system notification? This action cannot be undone.'
  }
};

export default en;
